module.exports = __webpack_public_path__ + "static/media/home_carousel_2S.42c86d80.png";